// State argument is not application state, only the state this reducer is responsible for
function notify(state = null, action) {
    switch (action.type) {
      case "SET_NOTIFY":
        return action.value;
      default:
        return state;
    }
  }
  export default notify;
  